import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../formTemplates/EntityManagement";
import EntityTable from "../templateComponents/EntityTable";

const Namespace = () => {
  const [formData, setFormData] = useState({
    bec_id: "",
    bec_reserved: "",
    bec_namespace_key: "",
    bec_est_id: "",
    waytern_id: "",
    bec_hex_identifier: "",
  });

  const [namespaces, setNamespaces] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);

  const firstFormFieldRef = useRef(null);

  const endpoints = {
    viewAll: "/view_beacon_namespace/v1.1",
    register: "/registration_beacon_namespace/v1.1",
    update: "/update_beacon_namespace/v1.1",
  };

  const loadNamespaces = async () => {
    try {
      const response = await axiosInstance.post(endpoints.viewAll, {
        view_type: "view all",
      });

      if (response.data.Status === "Success") {
        setNamespaces(response.data.Data || []);
      } else {
        console.error("API error:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching namespaces:", error);
    }
  };

  useEffect(() => {
    loadNamespaces();
  }, []);

  const handleFormSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    bec_ns_id: editingEntityId, 
    bec_id: parseInt(formData.bec_id, 10),
    bec_reserved: formData.bec_reserved,
    bec_namespace_key: formData.bec_namespace_key,
    bec_est_id: formData.bec_est_id,
    bec_unique_id_wayfinder: formData.waytern_id, 
    bec_hex_identifier: formData.bec_hex_identifier,
  };

  try {
    let response;
    if (editMode) {
      response = await axiosInstance.post(endpoints.update, payload);
    } else {
      response = await axiosInstance.post(endpoints.register, payload);
    }

    if (response.data.Status === "Success") {
      loadNamespaces();
      resetForm();
    } else {
      console.error(
        `${editMode ? "Update" : "Registration"} failed:`,
        response.data.Message
      );
    }
  } catch (error) {
    console.error(
      `${editMode ? "Update" : "Registration"} error:`,
      error
    );
  }
};

  const resetForm = () => {
    setFormData({
      bec_id: "",
      bec_reserved: "",
      bec_namespace_key: "",
      bec_est_id: "",
      waytern_id: "",
      bec_hex_identifier: "",
    });
    setEditMode(false);
    setEditingEntityId(null);
  };

  const handleEdit = (entityId) => {
    const entity = namespaces.find((ns) => ns.bec_ns_id === entityId);
    if (entity) {
      setFormData({
        bec_id: entity.bec_id,
        bec_reserved: entity.bec_reserved,
        bec_namespace_key: entity.bec_namespace_key,
        bec_est_id: entity.bec_est_id,
        waytern_id: entity.bec_unique_id_wayfinder,
        bec_hex_identifier: entity.bec_hex_identifier,
      });
      setEditMode(true);
      setEditingEntityId(entityId);
      if (firstFormFieldRef.current) firstFormFieldRef.current.focus();
      setIsTableModalOpen(false);
    }
  };

  const handleViewTableClick = () => {
    setIsTableModalOpen(true);
  };

  const formFields = [
    { name: "bec_id", label: "Beacon ID", type: "text", required: true },
    { name: "bec_reserved", label: "Reserved", type: "text", required: true },
    {
      name: "bec_namespace_key",
      label: "Namespace Key",
      type: "text",
      required: true,
    },
    { name: "bec_est_id", label: "Establishment ID", type: "text", required: true },
    { name: "waytern_id", label: "Waytern ID", type: "text", required: true },
    {
      name: "bec_hex_identifier",
      label: "Hex Identifier",
      type: "text",
      required: true,
    },
  ];

  const columns = [
    { name: "bec_ns_id", label: "Namespace ID" },
    { name: "bec_id", label: "Beacon ID" },
    { name: "bec_reserved", label: "Reserved" },
    { name: "bec_namespace_key", label: "Namespace Key" },
    { name: "bec_est_id", label: "Establishment ID" },
    { name: "bec_unique_id_wayfinder", label: "Waytern ID" },
    { name: "bec_hex_identifier", label: "Hex Identifier" },
   
  ];

  return (
    <div className="namespace">
      <EntityManagement
        entityName="Beacon Namespace"
        formFields={formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        firstFormFieldRef={firstFormFieldRef}
        handleViewTableClick={handleViewTableClick}
        onEdit={handleEdit}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>
            <EntityTable
              data={namespaces}
              columns={columns}
              onEdit={handleEdit}
              keyField="bec_ns_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Namespace;
